module.exports = __webpack_public_path__ + "static/media/slide6.f32795e0.jpg";